import React from "react";
import { IoMdClose } from "react-icons/io";
import MainFilterComponent from "./FilterComponents/MainFilterComponent";

const MainBottomSheetComponent = ({
  filterComponentIndex,
  changeFilterCompoIndex,
  onClose,
  onClearAll,
  allselectedFilters = [],
  selectedBedrooms = [],
  handleBedroomPress,
  selectedConustruction = [],
  handleConustructionPress,
  selectedPostedBy = [],
  handlePostedByPress,
  selectedSubcat = [],
  handleSubcatPress,
  selectedFurnished = [],
  handleFurnishedPress,
}) => {
  return (
    <div>
      <div className="rbstopcontent">
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <IoMdClose size={24} style={{ cursor: "pointer" }} onClick={() => onClose()} />
          <p className="filtertext" style={{ margin: 0 }}>Filters</p>
        </div>

        <p
          className="clearalltext"
          style={{
            cursor: "pointer",
            fontWeight: "600",
            color: allselectedFilters.length > 0 ? "#ea580c" : "#94a3b8",
            margin: 0,
            padding: "4px 8px",
          }}
          onClick={() => {
            if (onClearAll) onClearAll();
          }}
        >
          Clear All {allselectedFilters.length > 0 ? `(${allselectedFilters.length})` : ""}
        </p>
      </div>

      <div className="mainrbscontainer">
        <div className="slidervsbox">
          <div className={`rbsnav ${filterComponentIndex === 4 ? "active" : ""}`} onClick={() => changeFilterCompoIndex(4)}>
            <p>BHK</p>
          </div>
          <div className={`rbsnav ${filterComponentIndex === 5 ? "active" : ""}`} onClick={() => changeFilterCompoIndex(5)}>
            <p>Construction Status</p>
          </div>
          <div className={`rbsnav ${filterComponentIndex === 6 ? "active" : ""}`} onClick={() => changeFilterCompoIndex(6)}>
            <p>Posted by</p>
          </div>
          <div className={`rbsnav ${filterComponentIndex === 3 ? "active" : ""}`} onClick={() => changeFilterCompoIndex(3)}>
            <p>Property Type</p>
          </div>
          <div className={`rbsnav ${filterComponentIndex === 15 ? "active" : ""}`} onClick={() => changeFilterCompoIndex(15)}>
            <p>Furnishing status</p>
          </div>
          <div className={`rbsnav ${filterComponentIndex === 2 ? "active" : ""}`} onClick={() => changeFilterCompoIndex(2)}>
            <p>Budget</p>
          </div>
          <div className={`rbsnav ${filterComponentIndex === 7 ? "active" : ""}`} onClick={() => changeFilterCompoIndex(7)}>
            <p>Area</p>
          </div>
          <div className={`rbsnav ${filterComponentIndex === 8 ? "active" : ""}`} onClick={() => changeFilterCompoIndex(8)}>
            <p>Localities</p>
          </div>
          <div className={`rbsnav ${filterComponentIndex === 11 ? "active" : ""}`} onClick={() => changeFilterCompoIndex(11)}>
            <p>Amenities</p>
          </div>
          <div className={`rbsnav ${filterComponentIndex === 1 ? "active" : ""}`} onClick={() => changeFilterCompoIndex(1)}>
            <p>Verified</p>
          </div>
        </div>
        <div className="mainrbsbox">
          <MainFilterComponent
            filterComponentIndex={filterComponentIndex}
            selectedBedrooms={selectedBedrooms}
            handleBedroomPress={handleBedroomPress}
            selectedConustruction={selectedConustruction}
            handleConustructionPress={handleConustructionPress}
            selectedPostedBy={selectedPostedBy}
            handlePostedByPress={handlePostedByPress}
            selectedSubcat={selectedSubcat}
            handleSubcatPress={handleSubcatPress}
            selectedFurnished={selectedFurnished}
            handleFurnishedPress={handleFurnishedPress}
          />
        </div>
      </div>

      <div className="bottombuttonsboxes">
        <div className="cancelboxes">
          <p onClick={() => onClose()} style={{ cursor: "pointer" }}>Cancel</p>
        </div>
        <div className="seeallpropertiesboxes">
          <button onClick={() => onClose()} style={{ cursor: "pointer" }}>
            {allselectedFilters.length > 0 ? `Apply Filters (${allselectedFilters.length})` : "See All Properties"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MainBottomSheetComponent;
